'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.classNames = classNames;
function classNames(classSet) {
  return Object.keys(classSet).filter(function (key) {
    return classSet[key];
  }).join(' ');
}


//////////////////
// WEBPACK FOOTER
// ../~/react-github-button/lib/utils.js
// module id = 412
// module chunks = 0